import { z } from 'zod';
// JQ4-14 — US-ORG-006: Daily Summary Dashboard response contract.
// Shared Zod schema — single source of truth for backend serialization and
// frontend deserialization. Both sides MUST use this schema.
//
// All four fields are non-nullable non-negative integers.
// null amountPaidCents is coalesced to 0 at the repo layer (not exposed here).
export const dailySummarySchema = z.object({
    checkInsToday: z.number().int().nonnegative(),
    activeTicketsNow: z.number().int().nonnegative(),
    revenueToday: z.number().int().nonnegative(),
    pendingRetrievalCount: z.number().int().nonnegative(),
});
//# sourceMappingURL=daily-summary-schemas.js.map